import React, { useState } from 'react';
import { OptionButton } from './OptionButton';

export const CancelSurvey = ({ goToAlternatives, handleClose, setCancelReason }) => {
  const options = ['Stopped Trading', 'Taking a Break', 'Too Expensive', 'Something is Missing', 'Technical Issues'];
  const [reasons, setReasons] = useState<any>([]);
  const [otherReason, setOtherReason] = useState('');

  const handleClick = option => {
    if (reasons.includes(option)) {
      setReasons(reasons.filter(reason => reason !== option));
    } else {
      setReasons([...reasons, option]);
    }
  };

  const handleSurveySubmit = () => {
    if (reasons.length > 0 || otherReason) {
      setCancelReason(reasons.join(';') + (otherReason ? ' ' + otherReason : ''));
    }
    goToAlternatives();
  };

  return (
    <div>
      <div className="font-bold text-lg">What is your reason for cancelling?</div>
      <p className="text-sm my-2">
        We continue to improve the product and experience, this helps us to focus on the right things.
      </p>
      <div className="flex flex-col gap-2">
        {options.map((op, idx) => (
          <OptionButton index={idx} key={op} label={op} selectedVal={reasons} setMethod={handleClick} value={op} />
        ))}
        <div className="border-b border-bzblue-800 p-2 flex items-center">
          <div className="border border-bzblue-800 text-bzblue-800 mr-2 rounded-md text-xs bg-white w-6 h-6 flex items-center justify-center">
            {String.fromCharCode(65 + options.length)}
          </div>
          <input
            onChange={e => setOtherReason(e.target.value)}
            placeholder="Other Reason"
            type="text"
            value={otherReason}
          />
        </div>
      </div>
      <div className="text-sm flex gap-2 absolute bottom-0 right-0">
        <button className="border border-bzgrey-400 px-2 py-1 text-bzgrey-400 rounded-md" onClick={handleClose}>
          Close
        </button>
        <button
          className="border border-red-500 bg-red-500 px-2 py-1 text-white rounded-md"
          onClick={handleSurveySubmit}
        >
          Continue to Cancellation
        </button>
      </div>
    </div>
  );
};
